var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Camera"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.011 9.385V14.513L21 18V6L17.011 9.385Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.887 6H13.967C15.435 6 17 7.203 17 8.803V16.999C17.0027 17.2608 16.9016 17.513 16.719 17.7006C16.5363 17.8881 16.2868 17.9958 16.025 18H5.652C3.985 18 3 16.5 3 15L3.01 6.998C2.99119 6.87165 3.00004 6.74273 3.03596 6.62014C3.07187 6.49755 3.13398 6.38422 3.218 6.288C3.301 6.19297 3.40431 6.11783 3.52029 6.06814C3.63627 6.01846 3.76195 5.99551 3.888 6.001L3.887 6Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/Camera.7c3d2f392bb4878bde5cca0e827a2078.svg";
export { ForwardRef as ReactComponent };